import PercentIcon from '@mui/icons-material/Percent';
import { Box, Stack } from "@mui/material";
import { useEffect } from "react";
import { ToolsPanelToggleButton } from "../../../screens/positions-and-orders/controls";
import {
    usePortfolioSelection,
    usePortfolioManagement,
    usePortfolioProfile,
} from "../../../shared/contexts/portfolio-context/components/PortfolioContextProvider";

export function PortfolioPerformanceSwitcher() {
    const {
        selectedPortfolio,
    } = usePortfolioSelection();
    const {
        saveSelectedPortfolio,
    } = usePortfolioManagement();
    const {
        updateSelectedPortfolio,
    } = usePortfolioProfile();

    const isEnabled = selectedPortfolio?.portfolioSettings?.showPortfolioPerformance ?? false;
    const isUsingAnnualisedRoi =
        selectedPortfolio?.portfolioSettings?.usePortfolioAnnualisedRoi ?? false;

    useEffect(() => {
    }, [selectedPortfolio]);

    const onEnabledChanged = async () => {
        if (selectedPortfolio === null || selectedPortfolio.portfolioSettings === null) {
            return;
        }

        selectedPortfolio.portfolioSettings.showPortfolioPerformance = !isEnabled;
        await updateSelectedPortfolio();
        await saveSelectedPortfolio();
    };

    const onMetricChanged = async () => {
        if (selectedPortfolio === null || selectedPortfolio.portfolioSettings === null) {
            return;
        }

        selectedPortfolio.portfolioSettings.usePortfolioAnnualisedRoi = !isUsingAnnualisedRoi;
        await updateSelectedPortfolio();
        await saveSelectedPortfolio();
    };

    return (
        <Stack direction="row" spacing={0.5}>
            <ToolsPanelToggleButton
                isActivated={isEnabled}
                setIsActivated={onEnabledChanged}
                tooltipTextWhenActivated="Show portfolio balances"
                tooltipTextWhenDeactivated="Show portfolio performance"
            >
                <PercentIcon
                    sx={{
                        height: '18px',
                        width: '18px',
                    }}
                />
            </ToolsPanelToggleButton>
            <ToolsPanelToggleButton
                isActivated={isUsingAnnualisedRoi}
                setIsActivated={onMetricChanged}
                tooltipTextWhenActivated="AROI: ROI annualized over the portfolio lifecycle. Click to show ROI"
                tooltipTextWhenDeactivated="ROI: portfolio balance as a percentage of total invested capital. Click to show AROI"
                disabled={!isEnabled}
            >
                <Box
                    sx={{
                        fontSize: '15px',
                        fontWeight: 700,
                        lineHeight: 1,
                    }}
                >
                    Y
                </Box>
            </ToolsPanelToggleButton>
        </Stack>
    );
}
